import DOMPurify from "dompurify"
import { get } from "shared/lib/api"
import Spinner from "spin.js"

export default function fetchUserFeedbackInfoSections(opts = {}, callback) {
  const targetEl = document.getElementById(opts.targetId)
  if (!targetEl) return

  const path = opts.path
  const sections = opts.sections
  const spinner = new Spinner({
    length: 6,
    width: 4,
    radius: 20,
    corners: 0,
    top: "3em",
  })

  targetEl.style.position = "relative"
  targetEl.appendChild(spinner.spin().el)

  const sectionPromises = sections.map(section => {
    return get(`${path}.js?section=${section}`)
      .then(resp => {
        // since the sections are fetched async, this makes sure they'll stick to the
        // order in html
        const el = targetEl.querySelector(`.${section}`)
        el.insertAdjacentHTML("beforeend", DOMPurify.sanitize(resp.data))
        ReactRailsUJS.mountComponents(el)
        spinner.stop()
      })
      .catch(() => {
        spinner.stop()
        window.appendFlash("Couldn't load all data. Please try again later.", "danger")
      })
  })

  Promise.all(sectionPromises)
    .then(() => {
      callback()
    })
    .catch(() => {
      window.appendFlash("Couldn't load all data. Please try again later.", "danger")
    })
    .finally(() => {
      spinner.stop()
    })
}
